import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {ThemeContextProvider} from "./hooks/helpers/ThemeContextProvider";
import AuthenticationProvider from "./core/contexts/authentication/authentication-provider";
import {TranslationProvider} from "./core/contexts/translations/translation-provider";
import en from './services/translations/en.json';
import {ApplicationConfigs} from "./hooks/context/useApplicationConfigs";
import QueryClientProviderCustom from "./core/contexts/react-query/react-query-provider";
import './index.scss';
import {GoogleOAuthProvider} from "@react-oauth/google";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// PayMe does not ship an app service worker. Proactively unregister any stale
// worker (e.g. from an old dev build) so it can never cache or route live
// auth/API responses. OneSignal manages its own worker separately.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations
      .filter((registration) => !registration.active?.scriptURL.includes('OneSignal'))
      .forEach((registration) => registration.unregister());
  }).catch(() => undefined);
}

root.render(
  // <React.StrictMode>
  <TranslationProvider translations={{en}}>
    <AuthenticationProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
        <QueryClientProviderCustom>
          <ApplicationConfigs>
            <ThemeContextProvider>
              <BrowserRouter>
                <App/>
              </BrowserRouter>
            </ThemeContextProvider>
          </ApplicationConfigs>
        </QueryClientProviderCustom>
      </GoogleOAuthProvider>
    </AuthenticationProvider>
  </TranslationProvider>
  // </React.StrictMode>
);
